import { Col, Container, Image, Row, Stack } from "react-bootstrap"

const AboutWhyChooseUs = () => {
    return (
        <Container className="about-why-choose-us margin-bottom-70">
            <Row>
                <Col md="6">
                    <h3 className="section-title m-0">Why <span>Choose Us</span></h3> 
                    <p className="section-subtitle">We Use Latest Technology to Run Your Project</p>
                    <Stack className="about-why-choose-us-content flex-wrap flex-row align-items-start">
                        <Image src="/images/technology-integration.png" />
                        <Stack className="about-why-choose-us-content-list">
                            <label>Technology Integration</label>
                            <p>
                                We denounce with righteous indignation and dislike men who are beguiled and demoralized by the charms of pleasure of the moment
                            </p>
                        </Stack>
                    </Stack>
                    <Stack className="about-why-choose-us-content flex-wrap flex-row align-items-start">
                        <Image src="/images/certified-experts.png" />
                        <Stack className="about-why-choose-us-content-list">
                            <label>Certified Experts</label>
                            <p>
                                We denounce with righteous indignation and dislike men who are beguiled and demoralized by the charms of pleasure of the moment
                            </p>
                        </Stack>
                    </Stack>
                    <Stack className="about-why-choose-us-content flex-wrap flex-row align-items-start">
                        <Image src="/images/future-vision.png" />
                        <Stack className="about-why-choose-us-content-list">
                            <label>Future Vision and Mission</label>
                            <p>
                                We denounce with righteous indignation and dislike men who are beguiled and demoralized by the charms of pleasure of the moment
                            </p>
                        </Stack>
                    </Stack>
                </Col>
                <Col md="6" className="about-why-choose-us-img">
                    <Image className="ms-md-auto d-block" src="/images/About-why-choose-us.png" />
                </Col>
            </Row>
        </Container>
    )
}

export default AboutWhyChooseUs